export class Filter {
    public fromDate:Date;
    public toDate:Date;
 
}
